import React from "react";
import { Layout, Result } from "antd";
import { Outlet } from "react-router-dom";
import { t } from "i18next";
import SidebarSetting from "./SidebarSetting/index";
import { Util } from "common/util";
import "common/styles/tableSetting.css";
import "common/styles/custom.css";



export default function Setting() {
  return (
    <Layout style={{ flex: 1 }} id="menu-setting">
      {
        Util.getInstance().hasPermission("access", "setting")
          ?
          <>
            <SidebarSetting />
            <Layout style={{ padding: 20 }}>
              <Outlet />
            </Layout>
          </>
          :
          <Result
            status="403"
            title="403"
            subTitle={t("text_sorry_you_are_not_authorized_to_access_this_page")}
          />
      }

    </Layout>
  );
}
